import ContainerRoutes from "../quality_reports/container";
import ContainerProviderRoutes from "../quality_reports/container_provider";
import ProcessRoutes from "../quality_reports/process";

export default [
  ...ContainerRoutes,
  ...ContainerProviderRoutes,
  ...ProcessRoutes,
];
